import { createStore } from 'vuex'
import axios from 'axios'
import router from '../router/index'
import snackbar from './modules/snackbar'
import utils from './modules/utils'
import category from './modules/category'
import order from './modules/order'
import product from './modules/product'

export default createStore({
    state: {
        user: {},
        token: null,
        logged: false,
        targetUrl: null,
    },
    mutations: {
        setPermissoes(state, payload) {
            state.permissoes = payload
        },
        setLogged(state, payload) {
            state.logged = payload
        },
        setToken(state, payload) {
            if (payload == null) return state.token = null
            state.logged = true;
            state.token = payload;
            axios.defaults.headers.common['Authorization'] = `${payload}`;
            localStorage.setItem('STVATOR_TOKEN', payload);
            const data = payload.split('.');
            state.user = JSON.parse(decodeURIComponent(escape(atob(data[1]))));
        },
        destroyUser(state) {
            state.logged = false
            state.user = {}
            delete axios.defaults.headers.common['Authorization']
            localStorage.removeItem('STVATOR_TOKEN')
            router.push('/login')
        },
        setTargetUrl(state, payload) {
            state.targetUrl = payload
        },
    },
    actions: {
        logOff(context) {
            this.state.logged = false
            delete axios.defaults.headers.common['Authorization']
            localStorage.removeItem('STVATOR_TOKEN')
            context.commit('setTargetUrl', '/')
            context.commit('setLogged', false)
            context.commit('destroyUser', null)
        },
        setLogged(context, payload) {
            context.commit('setLogged', payload)
        },
        setTargetUrl(context, payload) {
            context.commit('setTargetUrl', payload)
        },
    },
    getters: {
        getUser(state) {
            return state.user
        },
        getToken(state) {
            return state.token
        },
        getLogged(state) {
            return state.logged
        },
        getAppBarTitle(){
            return process.env.VUE_APP_BAR_TITLE;
        },
        getTargetUrl(state){
            return state.targetUrl;
        }
    },
    modules: {
        snackbar,
        utils,
        category,
        order,
        product,
    }
})